import { IDataHandler } from '../IDataHandler';
import { UserEventName } from '../TrackingEvent';
import { UserDataSet } from '../DataSet/User';

const UserDataMap: {
    [key in UserEventName]: (keyof UserDataSet)[];
} = {
    [UserEventName.userUnification]: ["formerUserID", "newUserID"],
};

export class UserDataHandler implements IDataHandler<UserDataSet> {
    public data = new UserDataSet();

    public getEventData(eventName: UserEventName): UserDataSet {
        const result = {} as UserDataSet;
        UserDataMap[eventName].forEach(key => {
            result[key] = this.data[key];
        });

        // Reset data.
        if (eventName === UserEventName.userUnification) {
            this.clearData();
        }

        return result;
    }

    public clearData(): void {
        this.data = new UserDataSet();
    }
}
